
import React, { Component } from 'react';
import QuotaForm from './QuotaForm';
import QuotaMonitorService from "app/services/quotaMonitor.service";
import GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import './QuotaComponent.scss';

class QuotaMonitor extends Component {	
	constructor (props) {
	super(props);
		this.state = {			
			questionSetQuotas: [],
			questionSetQuotasOriginal: [],
			errorMessage: null,			
			uiBlocked: false
		}
	}
	
	componentDidMount() {		
		this.queryQuotas();		
	}

	queryQuotas() {
		this.toggleUiBlock(true);
		QuotaMonitorService.getLiveQuotas()
			.then(response =>{				
				this.setState({ 
					questionSetQuotas:  response.data,
					questionSetQuotasOriginal: cloneDeep(response.data),		
					loading: false				
				});
				this.toggleUiBlock(false);
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});
				this.toggleUiBlock(false);
			})
	}

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	}	

	updateQuestionSetQuotas(questionSetQuotas) {		
		this.setState({questionSetQuotas: questionSetQuotas})
	}

    render() {
        return (
			<BlockUi tag="div" blocking={this.state.uiBlocked}>  
			<main className="app-body quotasmonitor">
				<div className="app-content scrollbox">
					<QuotaForm toggleUiBlock={this.toggleUiBlock.bind(this)}
							questionSetQuotas={this.state.questionSetQuotas}
							questionSetQuotasOriginal={this.state.questionSetQuotasOriginal}							
							updateQuestionSetQuotas={this.updateQuestionSetQuotas.bind(this)}
							canChangeData={this.props.userPermissions?.CanChangeQuota}
							queryQuotas={this.queryQuotas.bind(this)}
							/>					
				</div>
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
				
			</main>
			</BlockUi>
        );
    }
}

export default QuotaMonitor;